import React from "react";
import Button from '@mui/material/Button';
import { ValidateVehicleAdminFuncInput } from "./ValidateVehicleAdminFuncInput";

const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  vehicle,
  navigate,
  _vehicleExist,
  _createErrorMessage,
  _deleteVehicle,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/VehicleOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationVehicleResult = ValidateVehicleAdminFuncInput(
      vehicle,
      _createErrorMessage
    );

    if (!validationVehicleResult) {
      return;
    }

    _vehicleExist({ data: { Id: vehicle } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("64");
        return;
      }
      _deleteVehicle({ data: { Id: vehicle } });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
